export default function Footer() {
  return (
    <footer className="bg-[#0A0A0A] relative overflow-hidden">
      {/* Circuit Pattern Background */}
      <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: 'linear-gradient(90deg, #333 1px, transparent 1px), linear-gradient(0deg, #333 1px, transparent 1px)',
        backgroundSize: '40px 40px'
      }}></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 md:px-8 py-10 sm:py-12 md:py-16 flex flex-col items-center text-center">
        {/* Brand */}
        <div className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-4">
          <img 
            src="https://public.readdy.ai/ai/img_res/e8d825e9-ac20-4b91-8ab7-2e86d27e2a3d.png" 
            alt="Nexus DI Logo" 
            className="h-8 w-8 sm:h-10 sm:w-10 object-contain"
          />
          <span className="text-xl sm:text-2xl font-bold text-white">Nexus DI</span>
        </div>

        <p className="text-[#999] text-sm sm:text-base mb-2">Inteligencia Artificial para Emprendedores Digitales</p>

        <div className="text-white mb-8 sm:mb-10 md:mb-12" style={{ fontFamily: 'Playfair Display, serif' }}>
          <p className="text-2xl sm:text-3xl font-semibold leading-tight">
            Domina la Venta de<br />
            <span className="text-[#FF6B35]">Productos Digitales en Tendencia</span>
          </p>
        </div>

        {/* Divider */}
        <div className="w-full h-px bg-[#222] mb-6 sm:mb-8"></div>

        {/* Bottom */}
        <div className="flex flex-col sm:flex-row items-center justify-between w-full gap-3 sm:gap-4">
          <p className="text-xs sm:text-sm text-[#666] text-center sm:text-left">
            © 2025 Nexus Digital Intelligence. Todos los derechos reservados.
          </p>
          <a href="#" className="text-xs sm:text-sm text-[#666] hover:text-[#FF6B35] transition-colors cursor-pointer">
            Política de Privacidad
          </a>
        </div>
      </div>
    </footer>
  );
}
